export default "__VITE_ASSET__a8e32048__"